const app = Vue.createApp({
    delimiters: ['${', '}'],
    data()  {
        return {

            //Global
            currency: '£',


            //Cart
            cartAddKey: '',
            cartAddTitle: '',
            cartLoaded: false,
            cartTitle: 'your <em>basket</em>',
            cartTotalItems: 0,
            cartData: {items: {}},
            cartQty: {},
            cartAvailable: {},
            cartOpen: false,
            cartErrorMessage: [],
            cartInfoMessage: [],
            cartDisableCheckout: false,
            cartAddBlocked: false,
            cartQuantityMessage: false,

            productVariantSelected: false,
            productOptionSelected: {},
            productID: false,
            productVariantID: false,
            productAvailableToBuy: false,
            productAvailableToPreOrder: false,
            productVariants: {},
            productQty: 1,

            TabOpen900: true,
            basketMessage: 'Add to bag - ',
            fullBasketMessage: null,
            productSelectedID: false,
            showBasket: false,

            toggleProductsMobile: false,
            defaultProductImage: true,

            forgotPassword: false,
            showAccount: true,
            showOrders: false,

            mobileStickyActive: true,

            newsletterDisabled: true,

            singlePackIDs : {
                43287878533349 : 43287878566117,
                43287882301669 : 43287882334437,
                43282444976357 : 43282445009125
            },

            smallTinIDArray: [
                '43287878467813',
                '43287878500581',
                '43282444910821',
                '43282444943589'
            ]


        }
    },
    watch: {
        productSelectedID: function () {
            this.setBasketPrice()
            this.checkIfVariantSelected()
        },
        productQty: function () {
            this.setBasketPrice()
        },
        showBasket: function () {
            if(this.showBasket) {
                document.querySelectorAll('html')[0].style.overflow = 'hidden';
            } else {
                document.querySelectorAll('html')[0].style.overflow = 'initial';

            }
        },
    },
    created() {
        this.cartGetData().then(() => {
            this.cartSetTotal();
            this.cartChecks();
            this.checkProductQueryParams();
        }).then(() => {
            this.cartLoaded = true;
        })
    },
    mounted() {
        this.productLoad();
        this.loadNewsletterSignup();
        // this.setBasketPrice();
    },
    computed: {
        cartCurrencySymbol() {
            if(document.getElementById('cart-data')) {
                return document.getElementById('cart-data').dataset.currency || '';
            }
        },
        cartItems() {
            if (this.cartData.items && this.cartData.items.length) {
                return this.cartData.items;
            }
        },
        toggleProductsMobileBoolean() {
            this.toggleProductsMobile = !this.toggleProductsMobile
            if(this.toggleProductsMobile) {
                this.toggleProductsMobile = false
            } else {
                this.toggleProductsMobile = true
            }
        }
    },
    methods: {
        // ***************
        // Cart Methods
        // ***************
        cartGetData() {
            return fetch('/cart.js', {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => response.json())
                .then(data => {
                    this.cartData = data;
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        },
        cartSetTotal() {
            this.cartTotalItems = this.cartData.item_count;
        },
        cartChecks() {

        },

        moneyFormat(amount) {
            return this.currency + (amount / 100).toFixed(2);
        },

        //Product
        productLoad() {
            let source = document.getElementById('product-data') || document.getElementById('product-bar-data');
            if(source) {
                this.productID = source.dataset.product || false;
                let variants = JSON.parse(source.dataset.variants || {});
                let indexedVariants = {};

                for (const variant in variants) {
                    console.log(variant.id)
                }

                let urlParams = new URLSearchParams(window.location.search);

                for (const variant in variants) {
                    indexedVariants[variants[variant].id] = variants[variant];


                    if (urlParams.has('variant')) {
                        if(variants[variant].id == urlParams.get('variant')) {
                            this.productSelectedID = urlParams.get('variant');
                            this.defaultProductImage = false;

                            if(variants[variant].title.includes('400')) {
                                this.TabOpen900 = false;
                            }
                        }
                    } else {
                        if (variants[variant].title === '900g tin') {
                            this.productSelectedID = variants[variant].id;
                        }
                    }
                }

                this.productVariants = indexedVariants;
            }
        },

        setBasketPrice() {
            this.productVariantSelected = this.productVariants[this.productSelectedID];
            let basketPriceAndQuantity = (this.productVariantSelected.price) * this.productQty;
            this.fullBasketMessage = this.basketMessage + this.moneyFormat(basketPriceAndQuantity);
        },

        setProductVariantID(variantID) {
            this.productSelectedID = variantID;
            this.defaultProductImage = false;

            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + variantID;
            window.history.pushState({path:newurl},'',newurl);
        },

        checkIfVariantSelected(variantID) {
            let isChecked = false;
            if (this.productSelectedID) {
                if (variantID == this.productSelectedID) {
                    isChecked = true
                }
            }

            return isChecked;
        },

        cartAddToCart(e) {

            id = this.productSelectedID;

            if (id) {

                let data = [];
        
                if(this.singlePackIDs[id] !== undefined && this.productQty >= 6) {
                    this.cartQuantityMessage = true;
                    this.consolidateSinglePacksIntoCase();
                } else {
                    data.push({
                        id: id,
                        quantity: this.productQty,
                        form_type: 'product'
                    });
    
    
                    let formData = {
                        'items': data
                    };
    
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => {
                        this.cartGetData().then(() => {
                            this.cartSetTotal();
                            this.showBasket = true;
                        });
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });

                }
            } else {
                this.cartAddBlocked = true;
            }
        },

        cartQtyUpdate(id, qty) {
            let payload = {
                'updates': {}
            };

            if(this.singlePackIDs[id] !== undefined && qty >= 6) {
                this.consolidateSinglePacksIntoCaseInCart(id, qty);
            } else {
                payload['updates'][id] = qty;

                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                })
                    .then(response => response.json())
                    .then(data => {
                        this.cartData = data;
                        this.cartErrorMessage = [];
                        this.cartInfoMessage = [];
                        this.cartDisableCheckout = false;
                        this.cartChecks();
                        this.cartSetTotal();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }

            return false;
        },

        logout() {
            window.location.href = '/account/logout';
        },

        toggleShowOrders() {
            this.showAccount = false;
            this.showOrders = true;
        },
        toggleShowAccount() {
            this.showAccount = true;
            this.showOrders = false;
        },
        toggleMobileSticky() {
            console.log('toggled preview')
            if(this.mobileStickyActive) {
                this.mobileStickyActive = false
            } else {
                this.mobileStickyActive = true
            }
        },

        consolidateSinglePacksIntoCase() {
            const fullCases = Math.floor(this.productQty / 6);
            const singleTins = this.productQty % 6;
            let data = [];

            if(singleTins > 0) {
                data.push({
                    id: id,
                    quantity: singleTins,
                    form_type: 'product'
                });


                let formData = {
                    'items': data
                };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }

            data.push({
                id: this.singlePackIDs[this.productSelectedID],
                quantity: fullCases,
                form_type: 'product'
            });


            let formData = {
                'items': data
            };

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                this.cartGetData().then(() => {
                    this.cartSetTotal();
                    this.showBasket = true;
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        },

        consolidateSinglePacksIntoCaseInCart(id, qty) {
            const fullCases = Math.floor(qty / 6);
            const singleTins = qty % 6;   
            let newData = [];

            let payload = {
                'updates': {}
            };

            // Update Single Tin Quantity
            payload['updates'][id] = 0;

            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    this.cartData = data;
                    this.cartErrorMessage = [];
                    this.cartInfoMessage = [];
                    this.cartDisableCheckout = false;
                    this.cartChecks();
                    this.cartSetTotal();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

                // Add Case Quanitity
                newData.push({
                    id: this.singlePackIDs[id],
                    quantity: fullCases,
                    form_type: 'product'
                });

                let formData = {
                    'items': newData
                };
    
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    this.cartGetData().then(() => {
                        this.cartSetTotal();
                        this.showBasket = true;
                    });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        },

        checkProductQueryParams() {
            const urlParams = new URLSearchParams(window.location.search);
            const myParam = urlParams.get('product_id');

            if(myParam !== null) {
                const isSmallTin = this.smallTinIDArray.includes(myParam)
                this.productSelectedID = parseInt(myParam);
                this.defaultProductImage = false;

                if(isSmallTin) {
                    this.TabOpen900 = false
                }
            }
        },

        validateEmail() {
            let emailString = document.getElementById('k_id_email');

            const emailValidation = String(emailString.value)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );

            if(emailValidation !== null && !String(emailString.value).includes("+")) {
                this.newsletterDisabled = false;
            } else {
                this.newsletterDisabled = true;
            }
        },

        // Delay loading of newsletter to reduce spam
        loadNewsletterSignup() {
            setTimeout(function(){document.getElementById("k_id_email").disabled = false;},3000);
        }

    }
});

app.mount('#app')
